import * as React from "react";
function SvgFolderMagnifier(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
        d="M26 31h5V5H13L9 1H1v30h15"
      />
      <circle
        cx={15}
        cy={18}
        r={5}
        transform="rotate(-30.54 15.004 17.99)"
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
      />
      <path
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
        d="M17.62 22l4.76 9"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgFolderMagnifier);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
